export enum ConfigurationKeys {
    INITIAL_MAP_CONFIGURATION = 'initial-map-configuration',
}